import React, { useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useDispatch, useSelector } from 'react-redux';

import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as glossaire_affichage_type_capteur from '../../../../ressources/glossaires/glossaire_affichage_type_capteur';
import * as actions from '../../../../services/actions';
import { customTotal } from '../../../UI/tableau/Tableau';

const TableauSensorType = ({ selectioneLigne }) => {
  // Redux hooks
  const dispatch = useDispatch();
  const sensorTypesList = useSelector(
    (state) => state.capteur.sensor_types_list
  );

  // State hooks
  const columns = [
    {
      dataField: 'sensor_type_id',
      text: checkMot('sensor_type_id'),
      sort: true,
    },
    {
      dataField: 'sensor_type_name',
      text: checkMot('sensor_type_name'),
      sort: true,
    },
    {
      dataField: 'sensor_type_display',
      text: checkMot('sensor_type_display'),
      sort: true,
      formatter: (cell) => {
        switch (cell) {
          case glossaire_affichage_type_capteur.default_display:
            return checkMot('default');
          case glossaire_affichage_type_capteur.notify:
            return checkMot('notify');
          default:
            return checkMot('default');
        }
      },
    },
    {
      dataField: 'sensor_type_path_image',
      text: checkMot('sensor_type_path_image'),
      sort: true,
    },
  ];

  // Effects
  useEffect(() => {
    dispatch(actions.reqRecupererListeSensorType());
  }, [dispatch]);

  // Table configurations
  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    style: {
      background: '#a6153e',
      color: 'white',
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        selectioneLigne(row);
      }
    },
  };

  const paginationOptions = {
    paginationSize: 25,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: 'All',
        value: sensorTypesList?.length || 0,
      },
    ],
  };

  if (!sensorTypesList?.length) {
    return null;
  }

  return (
    <BootstrapTable
      keyField="sensor_type_id"
      data={sensorTypesList}
      columns={columns}
      selectRow={selectRow}
      pagination={paginationFactory(paginationOptions)}
    />
  );
};

export default TableauSensorType;
